import { useNavigate } from '@tanstack/react-router';
import { TabsContent } from '@/components/ui/Tabs.tsx';
import TabScreen from '@/components/ui/TabScreen.tsx';
import {
  SETTINGS_TABS,
  settingsRoute,
  SettingsTab,
} from '@/features/dashboard/companySettings/routes/settingsRoute.ts';
import MessageTemplatesSection from '@/features/dashboard/messageTemplates/components/MessageTemplatesSection.tsx';
import { MessageChannel } from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';
import ConsentTemplatesList from '@/features/dashboard/consentTemplates/components/ConsentTemplatesList.tsx';
import CompanyInfo from '@/features/dashboard/company/components/CompanyInfo.tsx';
import PrefixesSection from '@/features/dashboard/companySettings/components/PrefixesSection.tsx';
import EmailSenderSection from '@/features/dashboard/emailSender/components/EmailSenderSection.tsx';
import DefaultCurrencySection from '@/features/dashboard/paymentConfig/components/DefaultCurrencySection.tsx';
import CostCategoriesList from '@/features/dashboard/costCategories/components/CostCategoriesList.tsx';
import PaymentConfig from '@/features/dashboard/paymentConfig/components/PaymentConfig.tsx';
import TagsList from '@/features/dashboard/tags/components/TagsList.tsx';

const CompanySettingsPage = () => {
  const { tab } = settingsRoute.useSearch();
  const navigate = useNavigate();

  return (
    <TabScreen
      tabs={SETTINGS_TABS}
      value={tab}
      onChange={(value) =>
        navigate({ to: '/app/company-settings', search: { tab: value } })
      }
      title="Ustawienia firmy"
      menuDescription="Konfiguracja widoczna dla wszystkich osób w firmie. Wybierz sekcję."
    >
      <TabsContent value={SettingsTab.COMPANY}>
        {/* Kreska między sekcjami, nigdy po ostatniej — stąd `divide` zamiast `space`. */}
        <div className="divide-y divide-neutral-200 [&>*:first-child]:pt-0 [&>*:last-child]:pb-0 [&>*]:py-5">
          <CompanyInfo />
          <PrefixesSection />
          <EmailSenderSection />
          <DefaultCurrencySection />
        </div>
      </TabsContent>

      <TabsContent value={SettingsTab.EMAIL_TEMPLATES}>
        <MessageTemplatesSection channel={MessageChannel.EMAIL} />
      </TabsContent>

      <TabsContent value={SettingsTab.SMS_TEMPLATES}>
        <MessageTemplatesSection channel={MessageChannel.SMS} />
      </TabsContent>

      <TabsContent value={SettingsTab.CONSENT_TEMPLATES}>
        <ConsentTemplatesList />
      </TabsContent>

      <TabsContent value={SettingsTab.COST_CATEGORIES}>
        <CostCategoriesList />
      </TabsContent>

      <TabsContent value={SettingsTab.PAYMENT_CONFIG}>
        <PaymentConfig />
      </TabsContent>

      <TabsContent value={SettingsTab.TAGS}>
        <TagsList />
      </TabsContent>
    </TabScreen>
  );
};

export default CompanySettingsPage;
